'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('../../extends-f8003900.js');
var objectWithoutProperties = require('../../objectWithoutProperties-aa43106a.js');
var React = require('react');
var formik_esm = require('../../formik.esm-b249f491.js');
var index = require('../../index-0e40e0c2.js');
var validateField = require('../../validateField-179f14cb.js');
var components_FieldErrorMessage_FieldErrorMessage = require('../FieldErrorMessage/FieldErrorMessage.js');
var FormContext = require('../../FormContext-e45f4589.js');
var components_Icon_Icon = require('../../Icon-97784f8d.js');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-02f83f64.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
require('../../utils/string/isString.js');
require('../../utils/isType/isType.js');
require('../Typography/Typography.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../colorBuilder-0e3465cf.js');
require('../../polished.esm-0312677e.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
require('../NuDSProvider/NuDSProvider.js');
require('../../breakpoints-7bb24b2d.js');
require('../../unsupportedIterableToArray-a6f9513d.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../GlobalStyle/GlobalStyle.js');
require('styled-components');
require('../../theme-340a6118.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../defineProperty-3cad0327.js');
require('../../xstyled-prop-types.es-56667676.js');
require('../../slicedToArray-e6d9072a.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject$2, _templateObject2$1;
var Label = xstyledStyledComponents_es.styled.label(_templateObject$2 || (_templateObject$2 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  line-height: 1.5;\n  color: ", ";\n  display: block;\n  position: relative;\n  padding-left: 32px;\n  cursor: pointer;\n  user-select: none;\n"])), styles_themeUtils.nuDSColor('black', 'defaultT70'));
Label.displayName = 'Label';
var LabelText = xstyledStyledComponents_es.styled.span(_templateObject2$1 || (_templateObject2$1 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  display: block;\n"])));
Label.displayName = 'LabelText';

var _templateObject$1, _templateObject2;
var Checkmark = xstyledStyledComponents_es.styled.span(_templateObject$1 || (_templateObject$1 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  position: absolute;\n  top: 2px;\n  left: 0;\n  background-color: ", ";\n  color: ", ";\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"])), styles_themeUtils.nuDSColor('white', 'defaultT70'), styles_themeUtils.nuDSColor('black', 'defaultT70'), styles_themeUtils.nuDSColor('primary'));
Checkmark.displayName = 'Checkmark';
var CheckboxInput = xstyledStyledComponents_es.styled.input(_templateObject2 || (_templateObject2 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n\n  &:checked ~ ", ",\n  &:hover ~ ", ",\n  &:focus ~ ", " {\n    color: ", ";\n  }\n"])), Checkmark, Checkmark, Checkmark, styles_themeUtils.nuDSColor('primary'));
CheckboxInput.displayName = 'CheckboxInput';

var _templateObject;
var CheckboxWrapper = xstyledStyledComponents_es.styled.div(_templateObject || (_templateObject = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  padding: 1rem 0 3rem;\n"])));
CheckboxWrapper.displayName = 'CheckboxWrapper';
CheckboxWrapper.defaultProps = {
  hasValidation: false
};
CheckboxWrapper.propTypes = {
  hasValidation: index.PropTypes.bool
};

var Checkbox = function Checkbox(_ref) {
  var id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      syncValidations = _ref.syncValidations,
      onChange = _ref.onChange,
      className = _ref.className,
      props = objectWithoutProperties.objectWithoutProperties(_ref, ["id", "label", "name", "syncValidations", "onChange", "className"]);

  var validations = FormContext.useFormValidations();

  var _useContext = React.useContext(formik_esm.FormikContext),
      values = _useContext.values;

  var errorMessageId = "error-".concat(name);
  var labelId = "label-".concat(name);
  var isRequired = Boolean(syncValidations.required);
  return /*#__PURE__*/React__default['default'].createElement(formik_esm.Field, {
    name: name,
    validate: validateField.validateField(validations, syncValidations, values)
  }, function (_ref2) {
    var field = _ref2.field,
        meta = _ref2.meta;
    var handleOnChange = React.useCallback(function (event) {
      field.onChange(event);
      onChange(event);
    }, [field.onChange, onChange]);
    var hasError = Boolean(meta.error);
    var isTouched = Boolean(meta.touched);
    var isChecked = Boolean(field.value);

    var a11yProps = _extends._extends({
      'aria-required': isRequired,
      'aria-invalid': hasError,
      'aria-labelledby': labelId
    }, hasError && {
      'aria-describedby': errorMessageId
    });

    return /*#__PURE__*/React__default['default'].createElement(CheckboxWrapper, {
      className: className
    }, /*#__PURE__*/React__default['default'].createElement(Label, {
      htmlFor: id,
      id: labelId
    }, /*#__PURE__*/React__default['default'].createElement(CheckboxInput, _extends._extends({}, a11yProps, field, props, {
      checked: field.value,
      touched: isTouched,
      id: id,
      required: isRequired,
      type: "checkbox",
      onChange: handleOnChange
    })), /*#__PURE__*/React__default['default'].createElement(Checkmark, {
      "aria-checked": field.value,
      "aria-labelledby": "label-".concat(name),
      role: "checkbox"
    }, isChecked ? /*#__PURE__*/React__default['default'].createElement(components_Icon_Icon.Icon, {
      name: "checkbox-fill",
      title: "Checkbox filled",
      "aria-hidden": "true"
    }) : /*#__PURE__*/React__default['default'].createElement(components_Icon_Icon.Icon, {
      name: "checkbox",
      title: "Checkbox not filled",
      "aria-hidden": "true"
    })), /*#__PURE__*/React__default['default'].createElement(LabelText, null, label)), /*#__PURE__*/React__default['default'].createElement(components_FieldErrorMessage_FieldErrorMessage['default'], {
      name: name,
      errorMessageId: errorMessageId,
      message: meta.error
    }));
  });
};

Checkbox.defaultProps = {
  className: undefined,
  onChange: function onChange() {},
  syncValidations: {}
};
Checkbox.propTypes = {
  className: index.PropTypes.string,
  id: index.PropTypes.string.isRequired,
  label: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.node]).isRequired,
  name: index.PropTypes.string.isRequired,
  onChange: index.PropTypes.func,
  syncValidations: index.PropTypes.objectOf(index.PropTypes.string)
};

exports.default = Checkbox;
//# sourceMappingURL=Checkbox.js.map
